import { MEDIA, MediaStats, StatProps } from "@bridgesplit/ui";

export function PortfolioTableStats({ stats, loading }: { stats: StatProps[]; loading: boolean }) {
    return <MediaStats variant="body1" query={MEDIA.MD} stats={stats} loading={loading} />;
}
